export default __webpack_public_path__ + "static/media/foto4.38e53edf.jpg";